import { Flexbox, Text } from '@morressier/ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ModalImage,
  Content,
  Description,
  ExitButton,
  Container
} from './style';

import { Button } from 'components/ProfileUIComponents';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

interface IExitContainer {
  showExitContainer: boolean;
  imageSrc?: string;
  title?: string;
  description?: string;
  onConfirm: () => void;
  onCancel: () => void;
  cancelActionText?: string;
  confirmActionText?: string;
  icon?: any;
}

const ExitContainer = (props: IExitContainer) => {
  const {
    showExitContainer,
    imageSrc = '/home-client/shared/svg-exit-warning.svg',
    title = 'Exit without saving?',
    description = 'Your work so far will not be saved for later.',
    onConfirm,
    onCancel,
    cancelActionText = 'Cancel',
    confirmActionText = 'Yes, exit without saving'
  } = props;

  return (
    <Container showExitContainer={showExitContainer} flexDirection="column">
      <Content
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <ModalImage src={imageSrc} />
        <Text size="h3_new" fontWeight="bold">
          {title}
        </Text>
        <Description>{description}</Description>
        <Flexbox gap="1rem" alignItems="center">
          <Button color="secondary" onClick={onCancel}>
            {cancelActionText}
          </Button>
          <Button color="error" onClick={onConfirm}>
            {confirmActionText}
          </Button>
        </Flexbox>
      </Content>
    </Container>
  );
};
export default ExitContainer;
